import { Inject, Injectable, InjectionToken } from '@angular/core';
import { MenuItem, MenuType } from '../MenuItems';

export const MENUITEM_PROVIDER = new InjectionToken<MenuItem[]>('MenuItem Provider', {
  providedIn: 'root',
  factory: () => []
});
@Injectable({
  providedIn: 'root'
})
export class MenuService {
  constructor( @Inject(MENUITEM_PROVIDER) public MenuItems: MenuItem[]) {}
  public getMenu(): MenuItem[] { return this.MenuItems; }
}
